'use client';
import { Button } from '@mui/material';
import FilterControllerIcon from './FilterControllerIcon';
import { FunctionComponent } from 'react';
import { ProductsContent } from '../../../graphql/pimcore/modules/siteContent/types/ProductsContent';

interface NormalFilterControllerProps {
    isFilterControllerOpen: boolean;
    toggleFilterController: () => void;
    contentTree: ProductsContent;
}

const NormalFilterController: FunctionComponent<NormalFilterControllerProps> = ({
    isFilterControllerOpen,
    toggleFilterController,
    contentTree,
}) => {
    return (
        <Button
            sx={{
                paddingLeft: '0.5rem',
                fontFamily: 'Poppins',
                fontWeight: 400,
                fontSize: 16,
                lineHeight: '1.125rem',
                color: 'black',
                textTransform: 'none', // 保持文字原狀
            }}
            startIcon={<FilterControllerIcon sx={{ color: 'black' }} />}
            onClick={toggleFilterController}
        >
            {isFilterControllerOpen
                ? contentTree.filters.buttonLabels.closeFilters.content
                : contentTree.filters.buttonLabels.openFilters.content}
        </Button>
    );
};

export default NormalFilterController;
